export default __webpack_public_path__ + "static/media/schoffe.da322652.jpg";